import React from "react"
import {FloatingCard} from "../FloatingCard/FloatingCard"
import {AiInsightsPending} from "./AiInsightsPending"
import {Badge} from "../Badge/Badge"
import {AiInsightsEmpty} from "./AiInsightsEmpty"
import {AiInsightsWithItems} from "./AiInsightsWithItems"
import {AiInsightsError} from "./AiInsightsError"

export type Insight = {
	title?: string
	description: string | JSX.Element
}

export interface AiInsightsViewProps {
	loading?: boolean
	error?: boolean
	items?: Insight[]
	enableClickAway?: boolean
	blockBodyScroll?: boolean
	close: () => void
}

export function AiInsightsView({
	loading,
	error,
	items = [],
	enableClickAway = false,
	blockBodyScroll = false,
	close,
}: AiInsightsViewProps) {
	let content: React.ReactNode

	if (loading) {
		content = <AiInsightsPending />
	} else if (error) {
		content = <AiInsightsError />
	} else if (items.length > 0) {
		content = <AiInsightsWithItems items={items} />
	} else {
		content = <AiInsightsEmpty />
	}

	return (
		<FloatingCard
			title="AI Insights"
			prefixIcon="ai-insight-recommend"
			suffix={<Badge text="Experimental" className="ml-3" textClassName="ai-insights-experimental-badge" />}
			onClose={close}
			enableClickAway={enableClickAway}
			blockBodyScroll={blockBodyScroll}
			className="ai-insights-card"
		>
			<div className="ai-insights-view">{content}</div>
		</FloatingCard>
	)
}
